import { CHATROOM_MESSAGES_LIMIT } from '../constants/chatroom'
import {
  createCommaSeparatedParam,
  deleteApi,
  getApi,
  getId2IdEndpoint,
  patchApi,
  postApi,
} from '../utils/api'

function getChatroomMessageEndpointBase({ outboundUuid, uuid }) {
  return getId2IdEndpoint({ outboundUuid, path: `pm/${uuid}` })
}

function getChatroomEndpointBase({ outboundUuid, uuid }) {
  return getId2IdEndpoint({ outboundUuid, path: `chatroom/${uuid}` })
}

export function createChatroomMessage({ data, outboundUuid }) {
  return postApi({
    data,
    endpoint: getId2IdEndpoint({ outboundUuid, path: 'pm/' }),
  })
}

export function createChatroomWithMessage({ data, outboundUuid }) {
  return postApi({
    data,
    endpoint: getId2IdEndpoint({ outboundUuid, path: 'chatroom/' }),
  })
}

export function deleteChatroomMessage({ outboundUuid, uuid }) {
  return deleteApi({
    endpoint: `${getChatroomMessageEndpointBase({ outboundUuid, uuid })}/`,
  })
}

export function likeChatroomMessage({ outboundUuid, uuid }) {
  return postApi({
    endpoint: `${getChatroomMessageEndpointBase({ outboundUuid, uuid })}/like/`,
  })
}

export function dislikeChatroomMessage({ outboundUuid, uuid }) {
  return deleteApi({
    endpoint: `${getChatroomMessageEndpointBase({ outboundUuid, uuid })}/like/`,
  })
}

export function getChatroomMessageTemplate({ data, id, options }) {
  return postApi({
    data,
    endpoint: `api/text-module/message-snippet/${id}/render/`,
    options,
  })
}

export function getChatroom({ options, outboundUuid, uuid }) {
  return getApi({
    endpoint: `${getChatroomEndpointBase({ outboundUuid, uuid })}/`,
    options,
  })
}

export function getChatroomFiles({ options, outboundUuid, uuid }) {
  return getApi({
    endpoint: `${getChatroomEndpointBase({ outboundUuid, uuid })}/files/`,
    options,
  })
}

export function massDownloadChatroomFiles({ outboundUuid, uuid }) {
  return postApi({
    endpoint: `${getChatroomEndpointBase({ outboundUuid, uuid })}/mass-download-files/`,
  })
}

export function getChatroomMembers({ options, outboundUuid, uuid }) {
  return getApi({
    endpoint: `${getChatroomEndpointBase({ outboundUuid, uuid })}/members/`,
    options,
  })
}

export function createChatroomMembers({ data, outboundUuid, uuid }) {
  return postApi({
    data,
    endpoint: `${getChatroomEndpointBase({ outboundUuid, uuid })}/members/`,
  })
}

export function deleteChatroomMembers({ ids, outboundUuid, uuid }) {
  return deleteApi({
    endpoint: `${getChatroomEndpointBase({ outboundUuid, uuid })}/members/`,
    params: { ids: createCommaSeparatedParam(ids) },
  })
}

export function readChatroom({ options, outboundUuid, uuid }) {
  return postApi({
    endpoint: `${getChatroomEndpointBase({ outboundUuid, uuid })}/read/`,
    options,
  })
}

export function updateChatroom({ data, outboundUuid, uuid }) {
  return patchApi({
    data,
    endpoint: `${getChatroomEndpointBase({ outboundUuid, uuid })}/`,
  })
}

export function getChatroomMessages({
  from,
  getPrev,
  limit = CHATROOM_MESSAGES_LIMIT,
  options,
  outboundUuid,
  uuid,
}) {
  const params = { limit }

  if (from) {
    params.from = from
  }

  if (getPrev) {
    params.get_prev = 1
  }

  return getApi({
    endpoint: `${getChatroomEndpointBase({ outboundUuid, uuid })}/messages/`,
    options,
    params,
  })
}

export function getChatroomMessage({ options, outboundUuid, uuid }) {
  return getApi({
    endpoint: `${getChatroomMessageEndpointBase({ outboundUuid, uuid })}/`,
    options,
  })
}

export function updateChatroomMessage({ data, outboundUuid, uuid }) {
  return patchApi({
    data,
    endpoint: `${getChatroomMessageEndpointBase({ outboundUuid, uuid })}/`,
  })
}
